import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "納品予定日", enum: "ANSWER" },
  { value: 2, text: "納品予約", enum: "RESERVE" },
]);
